import { render, staticRenderFns } from "./list.vue?vue&type=template&id=82697a8c&scoped=true"
import script from "./list.vue?vue&type=script&lang=ts"
export * from "./list.vue?vue&type=script&lang=ts"
import style0 from "./list.vue?vue&type=style&index=0&id=82697a8c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82697a8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/Cona-OSUM/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('82697a8c')) {
      api.createRecord('82697a8c', component.options)
    } else {
      api.reload('82697a8c', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=82697a8c&scoped=true", function () {
      api.rerender('82697a8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/moqs-discounts/list.vue"
export default component.exports